import { stripHtml } from "../../../shared/strip-html.js";
import { ContentArea } from "./ContentArea.js";
import { jsx } from "react/jsx-runtime";

//#region src/client/components/shared/ConsentBody.tsx
const ConsentBody = ({ consent, status }) => {
	return /* @__PURE__ */ jsx(ContentArea, { contents: (!stripHtml(consent.htmlContent) && status === "ACTIVE" ? consent.publishedConsentBox?.htmlContent : consent.htmlContent) ?? "" });
};

//#endregion
export { ConsentBody };